/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import * as actions from 'state/action-types';
import recieveReports from './recieve-reports';

export default  () => (dispatch) => {
	dispatch({
		type: actions.REPORTS_REQUEST,
	});
	return vd
		.widget()
		.listAll()
		.then((reports) => {
			dispatch({
				type: actions.REPORTS_REQUEST_SUCCESS,
			});
			dispatch(recieveReports(reports));
			return reports;
		});
};